<template>
  <div>
    <vxe-grid
      v-bind="xGridOptions"
      highlight-hover-row
      show-overflow="title" 
      border
      resizable
      height="575"
      @form-submit="onSubmitQuery"
      @form-reset="onReset"
      @cell-click="onCellClick"
      :loading="loading"
      :radio-config="{trigger:'row'}"
      :seq-config="{startIndex: (xGridOptions.pagerConfig.currentPage - 1) * xGridOptions.pagerConfig.pageSize}"
      :pager-config="xGridOptions.pagerConfig"
      @page-change="handlePageChange"
    >     
        <template v-slot:button="{ row }"  >
           <vxe-button  v-for="(item,index) in rowButtons" :key="index" status="primary" @click="onRowButtonClick(item.on,row)">{{item.buttonName}}</vxe-button>
        </template>
    </vxe-grid>
  </div>
</template>

<script>
import { MatchGoodsMQApi } from "api/base.js";
import FormGridPWindow from "components/grid/FormGridPWindow.vue";
import matterList from "components/grid/FormGridPWindow.vue";

export default {
  components: {
    matterList
  },
  props: {
    tableColumns: {
      Type: Array
    },
    queryForm:Object,
    rowButtons:{
      Type:Array,
      default(){
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      selectedList: [], //已选数据
      isShowMaterialDialog: false,
      fromData: {
        page:1,//当前页
      	pageSize:1000,//总数量,
      },
      selectedRow: undefined,//选中的行
      xGridOptions: {
        resizable: true, //列是否允许拖动列宽调整大小
        height: "100%",
        //分页信息
        pagerConfig: {
          total: 0,//总条数
          currentPage: 1,//当前页
          pageSize: 10,//每页大小
          align: "left",
          pageSizes: [10, 20, 50, 100],//每页大小选项列表
          layouts: [//自定义布局
            "Sizes",
            "PrevJump",
            "PrevPage",
            "Number",
            "NextPage",
            "NextJump",
            "FullJump",
            "Total"
          ],
          perfect: true
        },
        toolbar: {
          import: true,
          perfect: true,
          refresh: true,
          custom: true,
          export: true,
          zoom: true
        },
        data: [],
        exportConfig: {},
        importConfig: {
          remote: true,
          types: ["xlsx"],
          modes: ["insert"]
        },
        formConfig:this.queryForm||{},
        columns: this.tableColumns
      }
    };
  },
  created() {
    this.emitQueryEvent();
  },
  methods: {
    //分页
    searchEvent() {
      this.xGridOptions.pagerConfig.currentPage = 1;
     this.emitQueryEvent();
    },
    handlePageChange({ currentPage, pageSize }) {
      console.log(currentPage,pageSize)
      this.xGridOptions.pagerConfig.currentPage = currentPage;
      this.xGridOptions.pagerConfig.pageSize = pageSize;
      this.emitQueryEvent();
    },
    //查询
    onSubmitQuery() {
      console.log(this.xGridOptions.formConfig.data);
      this.fromData.searchCriteria = this.xGridOptions.formConfig.data;
      this.emitQueryEvent();
    },

    

    /**
     * 点击行button事件
     */
    onRowButtonClick(eventName,row){
       let vm=this;
       vm.selectedRow=row;
       vm.$emit(eventName,vm.selectedRow);
    },  
    onCellClick({row}){
       let vm=this;
       vm.selectedRow=row;
       vm.$emit("onRowCellClick",row);
    },
    /**
     * 触发查询
     */
    refresh(){
     
    },
    /**
     * 返回表格选项 */  
    getGridOptions(){
      return this.xGridOptions;
    },
    /**
     * 加载页面数据信息
     */
    loadPageData(pageData){
       let vm=this;
       if(!pageData){
         return;
       }
       vm.xGridOptions.data=pageData.list;       
       vm.xGridOptions.pagerConfig.currentPage = pageData.pageNum;
       vm.xGridOptions.pagerConfig.pageSize = pageData.pageSize;
    },

    /**
     * 获取选中的行
     */
    getSelectedRow(){
      let vm=this;
      return vm.selectedRow;
    },
    /**
     * 提交查询
     */
    emitQueryEvent(){
       let vm =this;
       vm.$emit("onSubmitQuery",vm);
    },
    //重置
    onReset() {
      this.xGridOptions.formConfig.data = {};
    },
    /**
     * 关联物料
     */
    onRelateMaterial(row) {
      this.EditData = row;
      console.log(this.EditData);
      this.isShowMaterialDialog = true;
    },
  }
};
</script>

